import React from 'react';
import { useDispatch } from 'react-redux';
import { Tooltip } from 'react-tooltip';
import { Icon } from '@fikasio/react-ui-components';
import { setPaneContent } from 'services/pane/slice';
import { useGetProjectsQuery } from 'services/projects/api';
import { invertColor } from 'utils/colors';

interface ProjectTagProps {
  onRemove?: () => void;
  projectId: string;
  truncate?: boolean;
}

const ProjectTag = ({
  onRemove,
  projectId,
  truncate = true,
}: ProjectTagProps) => {
  const { data: projects } = useGetProjectsQuery();
  const dispatch = useDispatch();
  const project = projects?.find(p => p.id === projectId);
  const displayName = project && truncate && project.name.length > 10
    ? project.name.substring(0, 10).concat('...')
    : project?.name;

  return project ? (
    <div
      data-tooltip-id={`project_${project.id}`}
      data-tooltip-content={project.name}
      onClick={
        () => {
          if (onRemove) {
            return;
          }
          dispatch(
            setPaneContent({
              type: 'PROJECT',
              id: project.id,
            })
          );
        }
      }
      style={{
        alignItems: 'center',
        backgroundColor: project.color,
        borderRadius: 3,
        color: project.color ? invertColor(project.color) : 'blue',
        cursor: onRemove ? 'default' : 'pointer',
        display: 'inline-flex',
        gap: 6,
        padding: '3px 5px',
        textDecoration: project.color || onRemove ? 'none' : 'underline',
      }}
    >
      <Tooltip
        id={`project_${project.id}`}
        portalRoot={document.body}
        positionStrategy="fixed"
        style={{ zIndex: 1000 }}
      />
      {displayName}
      {
        onRemove && (
          <Icon
            name="times"
            onClick={event => {
              event.stopPropagation();
              onRemove();
            }}
            size="1x"
            style={{
              cursor: 'pointer',
            }}
          />
        )
      }
    </div>
  ) : <div />;
};

export default ProjectTag;
